/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CommunityWin,
  CommunityWinCreationArgs,
  CommunityWinDeleteArgs,
  CommunityWinUpdateArgs,
  GetCommunityWinsParams,
  HTTPValidationError,
} from './platformapi.schemas';

import createCommunityWinMutator from '../custom-axios-instance';
import deleteCommunityWinMutator from '../custom-axios-instance';
import updateCommunityWinMutator from '../custom-axios-instance';
import getCommunityWinsMutator from '../custom-axios-instance';
import countCommunityWinsMutator from '../custom-axios-instance';

/**
 * Creates a new community win
 * @summary Create Community Win
 */
export const createCommunityWin = (
  communityWinCreationArgs: CommunityWinCreationArgs,
  signal?: AbortSignal,
) => {
  return createCommunityWinMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/community-wins/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: communityWinCreationArgs,
    signal,
  });
};

export const getCreateCommunityWinMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCommunityWin>>,
    TError,
    { data: CommunityWinCreationArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCommunityWin>>,
  TError,
  { data: CommunityWinCreationArgs },
  TContext
> => {
  const mutationKey = ['createCommunityWin'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCommunityWin>>,
    { data: CommunityWinCreationArgs }
  > = (props) => {
    const { data } = props ?? {};

    return createCommunityWin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCommunityWinMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCommunityWin>>
>;
export type CreateCommunityWinMutationBody = CommunityWinCreationArgs;
export type CreateCommunityWinMutationError = void | HTTPValidationError;

/**
 * @summary Create Community Win
 */
export const useCreateCommunityWin = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCommunityWin>>,
      TError,
      { data: CommunityWinCreationArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCommunityWin>>,
  TError,
  { data: CommunityWinCreationArgs },
  TContext
> => {
  const mutationOptions = getCreateCommunityWinMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a community win
 * @summary Delete Community Win
 */
export const deleteCommunityWin = (
  communityWinDeleteArgs: CommunityWinDeleteArgs,
  signal?: AbortSignal,
) => {
  return deleteCommunityWinMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/community-wins/delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: communityWinDeleteArgs,
    signal,
  });
};

export const getDeleteCommunityWinMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCommunityWin>>,
    TError,
    { data: CommunityWinDeleteArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCommunityWin>>,
  TError,
  { data: CommunityWinDeleteArgs },
  TContext
> => {
  const mutationKey = ['deleteCommunityWin'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCommunityWin>>,
    { data: CommunityWinDeleteArgs }
  > = (props) => {
    const { data } = props ?? {};

    return deleteCommunityWin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCommunityWinMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCommunityWin>>
>;
export type DeleteCommunityWinMutationBody = CommunityWinDeleteArgs;
export type DeleteCommunityWinMutationError = void | HTTPValidationError;

/**
 * @summary Delete Community Win
 */
export const useDeleteCommunityWin = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCommunityWin>>,
      TError,
      { data: CommunityWinDeleteArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCommunityWin>>,
  TError,
  { data: CommunityWinDeleteArgs },
  TContext
> => {
  const mutationOptions = getDeleteCommunityWinMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates an existing community win
 * @summary Update Community Win
 */
export const updateCommunityWin = (
  communityWinUpdateArgs: CommunityWinUpdateArgs,
  signal?: AbortSignal,
) => {
  return updateCommunityWinMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/community-wins/update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: communityWinUpdateArgs,
    signal,
  });
};

export const getUpdateCommunityWinMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunityWin>>,
    TError,
    { data: CommunityWinUpdateArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCommunityWin>>,
  TError,
  { data: CommunityWinUpdateArgs },
  TContext
> => {
  const mutationKey = ['updateCommunityWin'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCommunityWin>>,
    { data: CommunityWinUpdateArgs }
  > = (props) => {
    const { data } = props ?? {};

    return updateCommunityWin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCommunityWinMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCommunityWin>>
>;
export type UpdateCommunityWinMutationBody = CommunityWinUpdateArgs;
export type UpdateCommunityWinMutationError = void | HTTPValidationError;

/**
 * @summary Update Community Win
 */
export const useUpdateCommunityWin = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCommunityWin>>,
      TError,
      { data: CommunityWinUpdateArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCommunityWin>>,
  TError,
  { data: CommunityWinUpdateArgs },
  TContext
> => {
  const mutationOptions = getUpdateCommunityWinMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves currently available community wins
 * @summary Get Community Wins
 */
export const getCommunityWins = (params: GetCommunityWinsParams, signal?: AbortSignal) => {
  return getCommunityWinsMutator<CommunityWin[]>({
    url: `${import.meta.env['VITE_API_HOST']}/community-wins/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetCommunityWinsQueryKey = (params: GetCommunityWinsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/community-wins/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCommunityWinsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunityWins>>,
  TError = void | HTTPValidationError,
>(
  params: GetCommunityWinsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommunityWins>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCommunityWinsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommunityWins>>> = ({ signal }) =>
    getCommunityWins(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCommunityWins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCommunityWinsQueryResult = NonNullable<Awaited<ReturnType<typeof getCommunityWins>>>;
export type GetCommunityWinsQueryError = void | HTTPValidationError;

export function useGetCommunityWins<
  TData = Awaited<ReturnType<typeof getCommunityWins>>,
  TError = void | HTTPValidationError,
>(
  params: GetCommunityWinsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommunityWins>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunityWins>>,
          TError,
          Awaited<ReturnType<typeof getCommunityWins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCommunityWins<
  TData = Awaited<ReturnType<typeof getCommunityWins>>,
  TError = void | HTTPValidationError,
>(
  params: GetCommunityWinsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommunityWins>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunityWins>>,
          TError,
          Awaited<ReturnType<typeof getCommunityWins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCommunityWins<
  TData = Awaited<ReturnType<typeof getCommunityWins>>,
  TError = void | HTTPValidationError,
>(
  params: GetCommunityWinsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommunityWins>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Community Wins
 */

export function useGetCommunityWins<
  TData = Awaited<ReturnType<typeof getCommunityWins>>,
  TError = void | HTTPValidationError,
>(
  params: GetCommunityWinsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommunityWins>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCommunityWinsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves currently available community wins
 * @summary Count Community Wins
 */
export const countCommunityWins = (signal?: AbortSignal) => {
  return countCommunityWinsMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/community-wins/count`,
    method: 'GET',
    signal,
  });
};

export const getCountCommunityWinsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/community-wins/count`] as const;
};

export const getCountCommunityWinsQueryOptions = <
  TData = Awaited<ReturnType<typeof countCommunityWins>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countCommunityWins>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCountCommunityWinsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countCommunityWins>>> = ({ signal }) =>
    countCommunityWins(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof countCommunityWins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountCommunityWinsQueryResult = NonNullable<
  Awaited<ReturnType<typeof countCommunityWins>>
>;
export type CountCommunityWinsQueryError = void | HTTPValidationError;

export function useCountCommunityWins<
  TData = Awaited<ReturnType<typeof countCommunityWins>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof countCommunityWins>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countCommunityWins>>,
          TError,
          Awaited<ReturnType<typeof countCommunityWins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountCommunityWins<
  TData = Awaited<ReturnType<typeof countCommunityWins>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countCommunityWins>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countCommunityWins>>,
          TError,
          Awaited<ReturnType<typeof countCommunityWins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountCommunityWins<
  TData = Awaited<ReturnType<typeof countCommunityWins>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countCommunityWins>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count Community Wins
 */

export function useCountCommunityWins<
  TData = Awaited<ReturnType<typeof countCommunityWins>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countCommunityWins>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCountCommunityWinsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
